import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Dialog, DialogPortal, DialogOverlay, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";

export const QrSheet = ({ open = true, title, id, onClose, busy = false, children }) => (
  <Dialog open={open} onOpenChange={(value) => { if (!value && !busy) onClose(); }}>
    <DialogPortal>
      <DialogOverlay className="qr-sheet-overlay" data-testid={`${id}-overlay`} />
      <DialogPrimitive.Content className="qr-experience qr-sheet" data-testid={id} aria-describedby={undefined}
        onEscapeKeyDown={(e) => busy && e.preventDefault()} onPointerDownOutside={(e) => busy && e.preventDefault()}>
        <div className="qr-sheet-heading"><DialogTitle>{title}</DialogTitle>
          <button type="button" className="qr-icon-button" disabled={busy} onClick={onClose} aria-label="Close" data-testid={`${id}-close`}><X size={20} /></button>
        </div>
        {children}
      </DialogPrimitive.Content>
    </DialogPortal>
  </Dialog>
);